// extracted by mini-css-extract-plugin
module.exports = {"partnerLoadingIcon":"siM1U","disabledPartnerItem":"ATOga"};